import React, { useState } from "react";
import { styled, css, keyframes } from "styled-components";
import { FocusOn } from "react-focus-on";
import Portal from "../Portal";
import { Close } from "../../icons";
import mediaQueries from "../../styles/mediaQueries";
import { rem } from "../../utils";
import { Colors } from "../../styles";
import ModalDialogItem from "./MenuDialogItem";
const enterAnimationBackdrop = keyframes `
  0%   {opacity: 0; }
  100% {opacity: 1;}
`;
const enterAnimationModal = keyframes `
  0% {transform: translateY(100%)}
  100% {transform: translateY(0)}
`;
const closeAnimationModal = keyframes `
  0% {transform: translateY(0)}
  100% {transform: translateY(100%)}
`;
const DIALOG_CLOSE_TIME = 200;
const Backdrop = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.24);
  animation: ${enterAnimationBackdrop} 200ms linear;
  animation-iteration-count: 1;
`;
const StyledModal = styled.div `
  position: fixed;
  z-index: 999999;
  margin: auto;
  outline: none;
  background: #FFFFFF;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.25);
  width: 100%;
  color: ${Colors.BLACK};
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: ${enterAnimationModal} ${DIALOG_CLOSE_TIME}ms ease-in forwards;
  animation-iteration-count: 1;
  max-width: 768px;
  padding: ${rem(48)} ${rem(20)} ${rem(40)};
  left: 0;
  right: 0;
  bottom: 0;
  min-width: 18.75rem;
  transform: translateY(100%);

  ${(props) => props.closing &&
    css `
      animation: ${closeAnimationModal} ${DIALOG_CLOSE_TIME}ms ease-out forwards;
      ${mediaQueries.up("small") `
        animation: none;
      `}
    `}

  ${mediaQueries.up("small") `
    animation: none;
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    bottom: auto;
    max-height: 60vh;
  `}

`;
const MenuItems = styled.div `
  position: relative;
  overflow-y: auto;

  > * {
    margin-bottom: ${rem(8)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
const CustomContent = styled.div `
  position: relative;
  overflow-y: auto;
`;
const CloseButton = styled.button `
  position: absolute;
  right: ${rem(8)};
  top: ${rem(8)};
  border: 0;
  background: transparent;
  align-self: flex-end;
  cursor: pointer;
  padding: 0;
  margin: 0;
  height: ${rem(40)};
  width: ${rem(40)};
  z-index: 9999991;

  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    fill: #000000;
    width: ${rem(21)};
    height: ${rem(21)};
  }
`;
const Heading = styled.h1 `
  margin: 0;
  font-weight: 500;
  font-size: ${rem(24)};
  line-height: ${rem(32)};
  margin-bottom: ${rem(16)};
`;
export const MenuDialog = ({ onRequestClose, label, items, onItemClick, closeOnItemClick = true, closeLabel = "Close", children, }) => {
    const [closing, setClosing] = useState(false);
    const onClose = () => {
        setClosing(true);
        setTimeout(() => {
            onRequestClose();
        }, DIALOG_CLOSE_TIME);
    };
    const onItemClickHandler = (target) => {
        if (onItemClick) {
            onItemClick(target);
        }
        if (closeOnItemClick) {
            onClose();
        }
    };
    return (React.createElement(Portal, null,
        React.createElement(Backdrop, null),
        React.createElement(FocusOn, { onEscapeKey: onClose, onClickOutside: onClose },
            React.createElement(StyledModal, { closing: closing, "aria-labelledby": label },
                React.createElement(Heading, null, label),
                items && items.length > 0 ? (React.createElement(MenuItems, null, items.map((item) => (React.createElement(ModalDialogItem, { "data-cy": item.dataCy, onItemClick: onItemClickHandler, key: item.target || item.key, item: item }))))) : (React.createElement(CustomContent, null, children)),
                React.createElement(CloseButton, { type: "button", onClick: onClose, "aria-label": closeLabel },
                    React.createElement(Close, null))))));
};
export default MenuDialog;
//# sourceMappingURL=MenuDialog.js.map